// Cart drawer + AJAX cart
(function(){
  function qs(s,r){return (r||document).querySelector(s)}
  function money(cents){return (cents/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify&&Shopify.currency?Shopify.currency.active:'EUR'})}
  var dcpApi={open:function(){},close:function(){}};
  function openDrawer(){dcpApi.open('cart');}
  function closeDrawer(){dcpApi.close();}
  async function refresh(){
    var r=await fetch('/cart.js');var c=await r.json();
    try{document.dispatchEvent(new CustomEvent('dcnvts:cart',{detail:c}));}catch(e){}
    var body=qs('#cart-lines'),count=qs('#cart-count'),total=qs('#cart-total'),inline=qs('#cart-count-inline');
    if(count)count.textContent='('+c.item_count+')';
    if(inline)inline.textContent=c.item_count;
    if(total)total.textContent=money(c.total_price);
    if(!body)return;
    if(c.items.length===0){body.innerHTML='<p class="upper">Il tuo carrello è vuoto</p>';return;}
    body.innerHTML=c.items.map(function(i){
      return '<div class="line"><img src="'+(i.image||'')+'&width=144"><div class="line__mid" style="flex:1">'+
      '<div class="upper" style="font-size:12px">'+i.product_title+'</div>'+
      '<div style="color:var(--muted);font-size:12px">'+(i.variant_title||'')+'</div>'+
      '<div class="cart-qty">'+
        '<button class="cart-qty__b" data-key="'+i.key+'" data-q="'+(i.quantity-1)+'" aria-label="Meno">&minus;</button>'+
        '<span class="cart-qty__n">'+i.quantity+'</span>'+
        '<button class="cart-qty__b" data-key="'+i.key+'" data-q="'+(i.quantity+1)+'" aria-label="Piu">+</button>'+
      '</div>'+
      '<button data-key="'+i.key+'" data-q="0" class="rm">Rimuovi</button>'+
      '</div>'+
      '<div class="cart-line__price">'+money(i.final_price)+'</div>'+
      '</div>';
    }).join('');
    body.querySelectorAll('[data-key][data-q]').forEach(function(b){
      b.addEventListener('click',async function(){
        var q=parseInt(b.getAttribute('data-q'),10);if(isNaN(q)||q<0)q=0;
        await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.getAttribute('data-key'),quantity:q})});
        refresh();
      });
    });
  }
  window.dcnvtsCartRefresh=refresh;
  function initHeaderScroll(){
    var sh=qs('.site-header');
    if(!sh||!document.body.classList.contains('template-index'))return;
    var hero=qs('.dcnvts-home');
    function onScroll(){
      var trigger=hero?(hero.offsetHeight-sh.offsetHeight):120;
      if(window.scrollY>trigger){sh.classList.add('is-solid');}else{sh.classList.remove('is-solid');}
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    onScroll();
  }
  function initCommunity(){
    var pins=document.querySelectorAll('[data-ugc-pin]');
    pins.forEach(function(pin){
      pin.addEventListener('click',function(e){
        e.stopPropagation();
        var tag=pin.parentNode.querySelector('[data-ugc-tag]');
        var wasOpen=tag&&tag.classList.contains('open');
        document.querySelectorAll('.ugc__tag.open').forEach(function(t){t.classList.remove('open');});
        if(tag&&!wasOpen)tag.classList.add('open');
      });
    });
    document.addEventListener('click',function(){
      document.querySelectorAll('.ugc__tag.open').forEach(function(t){t.classList.remove('open');});
    });
    document.querySelectorAll('.ugc__tag').forEach(function(t){t.addEventListener('click',function(e){e.stopPropagation();});});
    document.querySelectorAll('.ugc__add-form').forEach(function(f){
      f.addEventListener('submit',async function(e){
        e.preventDefault();
        await fetch('/cart/add.js',{method:'POST',body:new FormData(f)});
        openDrawer();
      });
    });
  }
  function initNewsletterPopup(){
    var pop=document.getElementById('nlpop');
    if(!pop)return;
    var KEY='nl_popup_dismissed';
    function open(){pop.classList.add('open');}
    function close(){
      pop.classList.remove('open');
      var days=parseInt(pop.getAttribute('data-frequency')||'7',10);
      try{localStorage.setItem(KEY,String(Date.now()+days*86400000));}catch(e){}
    }
    pop.querySelectorAll('[data-nlpop-close]').forEach(function(el){el.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    if(pop.getAttribute('data-force-open')==='true'){open();return;}
    var until=0;try{until=parseInt(localStorage.getItem(KEY)||'0',10);}catch(e){}
    if(Date.now()<until)return;
    var delay=parseInt(pop.getAttribute('data-delay')||'3',10)*1000;
    setTimeout(open,delay);
  }
  function initPanels(){
    var panels={};
    document.querySelectorAll('.dcp').forEach(function(p){var n=p.getAttribute('data-panel');if(n)panels[n]=p;});
    function closeAll(){Object.keys(panels).forEach(function(k){panels[k].classList.remove('open');});document.body.style.overflow='';}
    function open(name){var p=panels[name];if(!p)return;Object.keys(panels).forEach(function(k){if(k!==name)panels[k].classList.remove('open');});p.classList.add('open');document.body.style.overflow='hidden';if(name==='cart')refresh();if(name==='search'){var inp=p.querySelector('.dcp__search-input');if(inp)setTimeout(function(){inp.focus();},80);}}
    document.querySelectorAll('[data-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();open(b.getAttribute('data-open'));});});
    document.querySelectorAll('[data-close]').forEach(function(b){b.addEventListener('click',function(e){if(b.tagName==='BUTTON'||b.classList.contains('dcp__overlay'))e.preventDefault();closeAll();});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});
    dcpApi.open=open;dcpApi.close=closeAll;window.__dcpOpen=open;window.__dcpClose=closeAll;
  }
  function initFilterDrawer(){
    var d=document.getElementById('filterdrawer');
    if(!d)return;
    function open(){d.classList.add('open');document.body.style.overflow='hidden';}
    function close(){d.classList.remove('open');document.body.style.overflow='';}
    document.querySelectorAll('[data-filter-open]').forEach(function(b){b.addEventListener('click',open);});
    d.querySelectorAll('[data-filter-close]').forEach(function(b){b.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }
  function initProductGallery(){
    var slider=document.getElementById('pdp-slider');
    if(!slider)return;
    var slides=slider.querySelectorAll('.pdp__slide');
    var dots=document.querySelectorAll('.pdp__dot, .pdp__thumb');
    var i=0;
    function w(){return slider.clientWidth;}
    function setDots(){dots.forEach(function(d,k){d.classList.toggle('active',k===i);});}
    function goTo(n){
      if(n<0)n=slides.length-1; if(n>slides.length-1)n=0; i=n;
      try{slider.scrollTo({left:i*w(),behavior:'smooth'});}catch(e){slider.scrollLeft=i*w();}
      setDots();
    }
    dots.forEach(function(d){d.addEventListener('click',function(){goTo(parseInt(d.getAttribute('data-thumb'),10)||0);});});

    // native scroll (fluid mobile swipe): keep the active dot in sync with the finger
    var raf=false;
    slider.addEventListener('scroll',function(){
      if(raf)return;raf=true;
      requestAnimationFrame(function(){
        raf=false;
        var n=Math.round(slider.scrollLeft/w());
        if(n<0)n=0; if(n>slides.length-1)n=slides.length-1;
        if(n!==i){i=n;setDots();}
      });
    },{passive:true});
    // wheel
    var wlock=false;
    slider.addEventListener('wheel',function(e){
      var d=Math.abs(e.deltaX)>Math.abs(e.deltaY)?e.deltaX:e.deltaY;
      if(Math.abs(d)<4)return;
      e.preventDefault();
      if(wlock)return;wlock=true;
      goTo(i+(d>0?1:-1));
      setTimeout(function(){wlock=false;},350);
    },{passive:false});

    window.addEventListener('resize',function(){slider.scrollLeft=i*w();});
    setDots();
  }
  function safe(fn){try{fn();}catch(e){}}
  function initQty(){
    var input=qs('#pdp-qty');if(!input)return;
    document.querySelectorAll('[data-qty-step]').forEach(function(b){
      b.addEventListener('click',function(){
        var step=parseInt(b.getAttribute('data-qty-step'),10)||0;
        var v=parseInt(input.value,10);if(isNaN(v))v=1;
        v=v+step;if(v<1)v=1;input.value=v;
      });
    });
  }
  function initEssential(){
    document.querySelectorAll('[data-mm]').forEach(function(root){
      var selectLabel=root.getAttribute('data-label-select')||'Seleziona le taglie';
      var addLabel=root.getAttribute('data-label-add')||'Aggiungi al carrello';
      var totalEl=root.querySelector('[data-total]');
      var addTop=root.querySelector('[data-add="top"]');
      var addSlip=root.querySelector('[data-add="slip"]');
      var mainBtn=root.querySelector('[data-add="set"]');
      var err=root.querySelector('[data-mm-err]');
      function models(group){var a=[];root.querySelectorAll('script.mm-data[data-group="'+group+'"]').forEach(function(s){try{a.push(JSON.parse(s.textContent));}catch(e){}});return a;}
      var tops=models('top'),slips=models('slip');
      function startIdx(g,len){var v=parseInt(root.getAttribute('data-mm-start-'+g),10);if(isNaN(v)||v<0||v>=len)v=0;return len?v:-1;}
      var st={top:{mi:startIdx('top',tops.length),v:null},slip:{mi:startIdx('slip',slips.length),v:null}};
      function each(sel,fn){root.querySelectorAll(sel).forEach(fn);}
      function recompute(){
        var tv=st.top.v,sv=st.slip.v;
        var tb=st.top.mi>=0?tops[st.top.mi].price:0, sb=st.slip.mi>=0?slips[st.slip.mi].price:0;
        var t=tv?tv.price:0,s=sv?sv.price:0;
        var total=(tv||sv)?(t+s):(tb+sb);
        if(totalEl)totalEl.textContent=money(total);
        if(addTop)addTop.disabled=!tv;
        if(addSlip)addSlip.disabled=!sv;
        var both=tv&&sv;
        if(mainBtn){mainBtn.disabled=!both;mainBtn.textContent=both?addLabel:selectLabel;}
      }
      function render(group){
        var arr=group==='top'?tops:slips, mi=st[group].mi;
        if(mi<0||!arr.length)return;
        var m=arr[mi];
        each('[data-mm-img="'+group+'"]',function(img){img.src=m.image||'';img.alt=m.title||'';});
        each('[data-mm-name="'+group+'"]',function(el){el.textContent=m.title||'';});
        each('[data-mm-price="'+group+'"]',function(el){el.textContent=money(m.price);});
        each('[data-mm-count="'+group+'"]',function(el){el.textContent=(mi+1)+' / '+arr.length;});
        each('[data-mm-sizes="'+group+'"]',function(sizes){
          sizes.innerHTML=(m.variants||[]).map(function(v,i){return '<button type="button" class="essential__size" data-vi="'+i+'"'+(v.available?'':' disabled aria-disabled="true"')+'>'+(v.label||'')+'</button>';}).join('');
          sizes.querySelectorAll('button').forEach(function(b){
            b.addEventListener('click',function(){
              if(b.disabled)return;
              sizes.querySelectorAll('button').forEach(function(x){x.classList.remove('active');});
              b.classList.add('active');
              st[group].v=m.variants[parseInt(b.getAttribute('data-vi'),10)];
              if(err)err.hidden=true;recompute();
            });
          });
        });
        st[group].v=null;recompute();
      }
      function go(group,dir){
        var arr=group==='top'?tops:slips;if(!arr.length)return;
        st[group].mi=((st[group].mi+dir)%arr.length+arr.length)%arr.length;
        render(group);
      }
      each('[data-mm-nav]',function(b){
        b.addEventListener('click',function(){go(b.getAttribute('data-mm-nav'),parseInt(b.getAttribute('data-dir'),10)||1);});
      });
      async function add(items,btn){
        if(err)err.hidden=true;var old=btn.textContent;btn.disabled=true;
        try{
          var res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
          if(!res.ok){var e=await res.json().catch(function(){return{};});if(err){err.textContent=(e&&e.description)||'Impossibile aggiungere al carrello.';err.hidden=false;}btn.disabled=false;btn.textContent=old;return;}
          if(window.__dcpOpen)window.__dcpOpen('cart');else refresh();
        }catch(e){if(err){err.textContent='Errore di rete. Riprova.';err.hidden=false;}}
        btn.disabled=false;btn.textContent=old;recompute();
      }
      if(addTop)addTop.addEventListener('click',function(){if(st.top.v)add([{id:st.top.v.id,quantity:1}],addTop);});
      if(addSlip)addSlip.addEventListener('click',function(){if(st.slip.v)add([{id:st.slip.v.id,quantity:1}],addSlip);});
      if(mainBtn)mainBtn.addEventListener('click',function(){if(st.top.v&&st.slip.v)add([{id:st.top.v.id,quantity:1},{id:st.slip.v.id,quantity:1}],mainBtn);});
      if(tops.length)render('top');
      if(slips.length)render('slip');
      recompute();
    });
  }
  function initRecentlyViewed(){
    var KEY='dcnvts_recent';
    var list=[];try{list=JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){list=[];}
    var curEl=qs('#dcnvts-current-product'),cur=null;
    if(curEl){try{cur=JSON.parse(curEl.textContent);}catch(e){}}
    if(cur&&cur.handle){
      list=list.filter(function(p){return p&&p.handle!==cur.handle;});
      list.unshift(cur);list=list.slice(0,12);
      try{localStorage.setItem(KEY,JSON.stringify(list));}catch(e){}
    }
    var sec=qs('[data-dcnvts-lastview]'),track=qs('#dcnvts-lastview-track');
    if(!sec||!track)return;
    var items=list.filter(function(p){return p&&p.handle&&(!cur||p.handle!==cur.handle);});
    if(items.length===0)return;
    function esc(s){return String(s||'').replace(/"/g,'&quot;');}
    track.innerHTML=items.map(function(p){
      var img=p.image?'<img src="'+p.image+'" alt="'+esc(p.title)+'" loading="lazy">':'';
      return '<article class="card"><div class="card__box"><div class="card__slider"><a class="card__slide" href="'+p.url+'">'+img+'</a></div></div>'+
             '<div class="card__info"><h3 class="card__title"><a href="'+p.url+'">'+(p.title||'')+'</a></h3><div class="price">'+(p.price||'')+'</div></div></article>';
    }).join('');
    sec.hidden=false;
  }
  function initCartNote(){
    var ta=qs('#cart-note');if(!ta)return;
    var hidden=qs('#cart-note-hidden'),t=null;
    ta.addEventListener('input',function(){
      if(hidden)hidden.value=ta.value;
      clearTimeout(t);
      t=setTimeout(function(){try{fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:ta.value})});}catch(e){}},600);
    });
  }
  function initGeo(){
    var el=qs('#dcnvts-geo');if(!el)return;
    var KEY='dcnvts_geo_seen',editor=window.Shopify&&Shopify.designMode;
    function getSeen(){try{if(localStorage.getItem(KEY))return true;}catch(e){}return document.cookie.indexOf(KEY+'=1')!==-1;}
    function setSeen(){try{localStorage.setItem(KEY,'1');}catch(e){}try{document.cookie=KEY+'=1; max-age=31536000; path=/';}catch(e){}}
    if(getSeen()&&!editor)return;
    el.hidden=false;requestAnimationFrame(function(){el.classList.add('show');});
    function close(){setSeen();el.classList.remove('show');setTimeout(function(){el.hidden=true;},300);}
    el.querySelectorAll('[data-geo-close]').forEach(function(b){b.addEventListener('click',close);});
    var form=el.querySelector('form');
    if(form)form.addEventListener('submit',function(e){ if(editor){e.preventDefault();close();return;} setSeen(); });
  }
  function initCookie(){
    var el=document.getElementById('dcnvts-cookie');if(!el)return;
    var KEY=el.getAttribute('data-key')||'dcnvts_cookie_ok';
    var editor=window.Shopify&&Shopify.designMode;
    var seen=false;try{seen=!!localStorage.getItem(KEY);}catch(e){}
    if(seen&&!editor)return;
    el.hidden=false;requestAnimationFrame(function(){el.classList.add('show');});
    function dismiss(){try{localStorage.setItem(KEY,String(Date.now()));}catch(e){}el.classList.remove('show');setTimeout(function(){el.hidden=true;},320);}
    el.querySelectorAll('[data-cookie-dismiss]').forEach(function(b){b.addEventListener('click',dismiss);});
  }
  // Product form: real variant matching + robust add-to-cart
  function initProductForm(){
    var form=qs('#product-form');
    if(!form)return;
    var variants=[];
    try{var vj=qs('#product-variants-json');variants=vj?JSON.parse(vj.textContent):[];}catch(e){variants=[];}
    var labels={add:'Aggiungi al carrello',soldout:'Sold out',unavailable:'Non disponibile'};
    try{var lj=qs('#product-labels-json');if(lj){var o=JSON.parse(lj.textContent);for(var k in o)labels[k]=o[k];}}catch(e){}
    var idInput=qs('#selected-variant'),addBtn=qs('#add-to-cart'),priceEl=qs('#pdp-price'),errEl=qs('#product-form-error');
    var groups=form.querySelectorAll('[data-variant-group]');
    function selectedValues(){var vals=[];groups.forEach(function(g){var a=g.querySelector('.swatch.active');vals.push(a?a.getAttribute('data-value'):null);});return vals;}
    function findVariant(vals){for(var i=0;i<variants.length;i++){var v=variants[i],ok=true;for(var j=0;j<vals.length;j++){if(String(v.options[j])!==String(vals[j])){ok=false;break;}}if(ok)return v;}return null;}
    function setPrice(v){if(!priceEl)return;if(v.compare_at_price&&v.compare_at_price>v.price){priceEl.innerHTML='<del style="color:var(--muted)">'+money(v.compare_at_price)+'</del> <span style="color:var(--sale)">'+money(v.price)+'</span>';}else{priceEl.textContent=money(v.price);}}
    function update(){
      var v=findVariant(selectedValues());
      if(!v){if(idInput)idInput.value='';if(addBtn){addBtn.disabled=true;addBtn.textContent=labels.unavailable;}return;}
      if(idInput)idInput.value=v.id;
      setPrice(v);
      if(addBtn){addBtn.disabled=!v.available;addBtn.textContent=v.available?labels.add:labels.soldout;}
    }
    groups.forEach(function(g){g.querySelectorAll('.swatch').forEach(function(s){s.addEventListener('click',function(){
      g.querySelectorAll('.swatch').forEach(function(x){x.classList.remove('active');});
      s.classList.add('active');
      if(errEl)errEl.style.display='none';
      update();
    });});});
    update();
    form.addEventListener('submit',async function(e){
      e.preventDefault();
      if(errEl)errEl.style.display='none';
      if(!idInput||!idInput.value){if(errEl){errEl.textContent='Seleziona una variante disponibile.';errEl.style.display='block';}return;}
      if(addBtn)addBtn.disabled=true;
      try{
        var res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!res.ok){var err=await res.json().catch(function(){return{};});if(errEl){errEl.textContent=(err&&err.description)||'Impossibile aggiungere al carrello.';errEl.style.display='block';}update();return;}
        openDrawer();refresh();
      }catch(err){if(errEl){errEl.textContent='Errore di rete. Riprova.';errEl.style.display='block';}}
      finally{update();}
    });
  }
  document.addEventListener('DOMContentLoaded',function(){
    safe(initHeaderScroll);
    safe(initCommunity);
    safe(initNewsletterPopup);
    safe(initPanels);
    safe(initFilterDrawer);
    safe(initProductGallery);
    safe(initProductForm);
    safe(initQty);
    safe(initEssential);
    safe(initRecentlyViewed);
    safe(initCartNote);
    safe(initGeo);
    safe(initCookie);
    refresh();
  });
})();

/* ===== DCNVTS: NOTIFY ME / campanella collegati all'app STOQ + slider prodotti =====
   STOQ (app embed) espone window._RestockRocket.openModal(productData, variantId).
   I dati del prodotto li leggiamo dalla pagina prodotto (#product-json) o da /products/<handle>.js */
(function(){
  var cache={};
  function getRR(){return window._RestockRocket||window.RestockRocket||null;}
  function waitRR(cb){var n=0;(function t(){var rr=getRR();if(rr&&typeof rr.openModal==='function')return cb(rr);if(++n>40)return cb(null);setTimeout(t,150);})();}
  function productJson(btn){
    return new Promise(function(res){
      var el=btn.hasAttribute('data-pdp-bell')&&document.getElementById('product-json');
      if(el){try{return res(JSON.parse(el.textContent));}catch(e){}}
      var url=btn.getAttribute('data-url');
      if(!url)return res(null);
      if(cache[url])return res(cache[url]);
      fetch(url.split('?')[0]+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(j){cache[url]=j;res(j);}).catch(function(){res(null);});
    });
  }
  function currentVariant(btn){
    var vid=btn.getAttribute('data-variant-id');
    if(btn.hasAttribute('data-pdp-bell')){var idEl=document.getElementById('selected-variant');if(idEl&&idEl.value)vid=idEl.value;}
    return String(vid||'');
  }
  function fallback(btn,vid){
    var url=btn.getAttribute('data-url');
    if(url){location.href=url.split('?')[0]+'?variant='+vid+'#notify';return;}
    var own=document.querySelector('[class*="restock-rocket"] button,[id*="restock-rocket"] button,[class*="stoq"] button,[id*="stoq"] button');
    if(own&&own!==btn){own.click();return;}
    // STOQ non risponde: mostra il modulo email di riserva (mai un pulsante "morto")
    if(window.console)console.warn('[DCNVTS] STOQ non trovato (window._RestockRocket assente): controlla Personalizza > Impostazioni tema > Incorpora app > STOQ');
    var fb=document.getElementById('pdp-notify-fb');
    if(fb){fb.hidden=false;var em=document.getElementById('pdp-notify-email');if(em)em.focus();}
  }
  (function(){
    var send=document.getElementById('pdp-notify-send');if(!send)return;
    send.addEventListener('click',function(){
      var em=document.getElementById('pdp-notify-email'),msg=document.getElementById('pdp-notify-msg');
      if(!em||!em.value||em.value.indexOf('@')<1){if(em)em.reportValidity&&em.reportValidity();return;}
      var idEl=document.getElementById('selected-variant'),vt='';
      try{var vs=JSON.parse(document.getElementById('product-variants-json').textContent);for(var i=0;i<vs.length;i++){if(idEl&&String(vs[i].id)===String(idEl.value)){vt=vs[i].title;break;}}}catch(e){}
      var fd=new FormData();
      fd.append('form_type','customer');fd.append('utf8','\u2713');
      fd.append('contact[email]',em.value);
      fd.append('contact[tags]','avvisami,avvisami-'+send.getAttribute('data-handle')+(vt?','+('avvisami-'+send.getAttribute('data-handle')+'-'+vt).toLowerCase().replace(/[^a-z0-9-]+/g,'-'):''));
      send.disabled=true;
      fetch('/contact',{method:'POST',body:fd}).then(function(){if(msg)msg.hidden=false;em.value='';}).catch(function(){if(msg)msg.hidden=false;}).finally(function(){send.disabled=false;});
    });
  })();
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-dcnvts-notify]');
    if(!btn)return;
    e.preventDefault();e.stopPropagation();
    var vid=currentVariant(btn);
    btn.setAttribute('aria-busy','true');
    Promise.all([productJson(btn),new Promise(function(r){waitRR(r);})]).then(function(v){
      btn.removeAttribute('aria-busy');
      var pdata=v[0],rr=v[1];
      if(rr){
        try{ if(pdata){rr.openModal(pdata,vid);}else{rr.openModal();} return; }catch(err){}
      }
      if(window.Stoq&&typeof window.Stoq.openModal==='function'){
        try{window.Stoq.openModal({productId:Number(btn.getAttribute('data-product-id')),variantId:Number(vid)});return;}catch(err){}
      }
      fallback(btn,vid);
    });
  },true);

  // Campanella: visibile solo quando il pulsante "aggiungi" è disattivato (variante esaurita / non ancora uscita)
  var bell=document.getElementById('pdp-bell'),add=document.getElementById('add-to-cart');
  if(bell&&add){
    var sync=function(){bell.hidden=!add.disabled;};
    sync();
    new MutationObserver(sync).observe(add,{attributes:true,attributeFilter:['disabled']});
  }
  // Arrivo da una card "NOTIFY ME": apre subito il modulo STOQ
  if(bell&&location.hash==='#notify'){setTimeout(function(){bell.click();},300);}

  // Slider prodotti: frecce
  document.querySelectorAll('.dps').forEach(function(sec){
    var tr=sec.querySelector('[data-dps-track]');if(!tr)return;
    var step=function(d){tr.scrollBy({left:d*Math.max(tr.clientWidth*0.8,200),behavior:'smooth'});};
    var p=sec.querySelector('[data-dps-prev]'),n=sec.querySelector('[data-dps-next]');
    if(p)p.addEventListener('click',function(){step(-1);});
    if(n)n.addEventListener('click',function(){step(1);});
  });
})();

/* ===== DCNVTS: prodotti IN SALDO nel carrello (aggiunta rapida) ===== */
(function(){
  function hideInCart(c){
    var ids={};(c.items||[]).forEach(function(i){ids[i.product_id]=1;});
    var any=false;
    document.querySelectorAll('[data-dup-product]').forEach(function(el){var h=!!ids[el.getAttribute('data-dup-product')];el.hidden=h;if(!h)any=true;});
    var box=document.querySelector('[data-dup]');if(box)box.hidden=!any;
  }
  document.addEventListener('dcnvts:cart',function(e){hideInCart(e.detail||{});});
  document.addEventListener('click',async function(e){
    var b=e.target.closest&&e.target.closest('[data-dup-add]');if(!b)return;
    e.preventDefault();
    var item=b.closest('.dup__item'),sel=item&&item.querySelector('.dup__var');if(!sel||!sel.value)return;
    var t=b.textContent,msg=document.querySelector('[data-dup-msg]');b.disabled=true;b.textContent='…';if(msg)msg.hidden=true;
    try{
      // stesso metodo del pulsante "Aggiungi al carrello" della pagina prodotto (FormData)
      var fd=new FormData();fd.append('id',sel.value);fd.append('quantity','1');
      var r=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd,credentials:'same-origin'});
      if(r.ok){b.textContent='✓';}
      else{var er=await r.json().catch(function(){return{};});b.textContent=t;if(msg){msg.textContent=(er&&(er.description||er.message))||'Impossibile aggiungere questo prodotto.';msg.hidden=false;}}
      if(window.dcnvtsCartRefresh)await window.dcnvtsCartRefresh();
    }catch(err){b.textContent='Riprova';if(window.console)console.warn('[DCNVTS] aggiunta saldo',err);}
    setTimeout(function(){b.disabled=false;b.textContent=t;},1400);
  });
})();
